import Serializable from '@/data/dtos/Serializable';

export class EventTicketDTO extends Serializable<EventTicketDTO> {


	public id: string;
	public visibility: number;
	public currency: string;
	public price: number;
	public minQuantity: number;
	public title: string;
	public expiresAt: Date|null;
	public description: string|null;

	constructor(data: Partial<EventTicketDTO>) {
		super();
		this.id = data.id || "";
		this.visibility = data.visibility || 0;
		this.currency = data.currency || "";
		this.price = data.price || 0;
		this.minQuantity = data.minQuantity || 1;
		this.title = data.title || "";
		this.expiresAt = Serializable.toDate(data.expiresAt);
		this.description = data.description || null;
	}

	public isVisible(): boolean {
		return this.visibility == 1;
	}

	public isUnlisted(): boolean {
		return this.visibility == 10;
	}

	public isExpired(): boolean {
		if (this.expiresAt == null) {
			return false;
		}
		const now = new Date();
		return this.expiresAt < now;
	}

}

